exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vertical {\n  position: absolute;\n  -webkit-transform: rotate3d(1, 1, 23, 269deg);\n          transform: rotate3d(1, 1, 23, 269deg);\n  left: -15px;\n  top: 40px;\n}\n", ""]);

// exports
